import { requestWithPromise } from '..'
import { DELETE, GET, PATCH, POST, makeQueryString } from '../apiHelper'

export const createUser = (user, newUser, disabledErrorHandler = true, followError = true) => {
  return requestWithPromise(
    '/user/create',
    POST,
    newUser,
    user,
    disabledErrorHandler,
    followError
  )
}

export const deleteUser = (user, userToDelete) => {
  return requestWithPromise(
    `/api/User/${userToDelete.id}`,
    DELETE,
    null,
    user,
    true,
    true
  )
}

export const getRoles = user => {
  return requestWithPromise(
    '/api/roles',
    GET,
    null,
    user
  )
}

export const getUsers = (filter, user, excludeAdmins = 0, role = null) => {
  let url = `/users?excludeAdminUsers=${excludeAdmins}&newFilter=${filter}`

  if (typeof role === 'string') {
    url += '&role=' + role
  }

  return requestWithPromise(
    url,
    GET,
    null,
    user
  )
}

export const getMe = token => {
  return requestWithPromise(
    '/user/me',
    GET,
    null,
    { token, switchUser: null },
    true,
    true
  )
}

export const getPaginateUsers = (user, parameters) => {
  return requestWithPromise(
    `/api/users${makeQueryString(parameters)}`,
    GET,
    null,
    user
  )
}

export const addSupervisorStudents = (user, body, currentUser) => {
  return requestWithPromise(
    `/api/users/${user.id}/supervised-students`,
    POST,
    body,
    currentUser
  )
}

export const deleteSupervisorStudents = (user, studentId, currentUser) => {
  return requestWithPromise(
    `/api/users/${user.id}/supervised-students/${studentId}`,
    DELETE,
    null,
    currentUser
  )
}

export const getSupervisorStudents = (user, currentUser, valueSearch = '') => {
  const search = typeof valueSearch !== 'undefined' ? `?search=${valueSearch}` : ''

  return requestWithPromise(
    `/api/users/${user.id}/supervised-students${search}`,
    GET,
    null,
    currentUser
  ).then(json => {
    return json?.data ?? {}
  })
}

export const getCountSupervisorStudents = user => {
  return requestWithPromise(
    '/user/supervised-students-count',
    GET,
    null,
    user
  ).then(json => {
    return json?.data ?? {}
  })
}

export const getUserOptins = user => {
  return requestWithPromise(
    `/api/users/${user.id}/optins`,
    GET,
    null,
    user
  )
}

export const createUserOptin = (optin, user) => {
  return requestWithPromise(
    `/api/users/${user.id}/optins`,
    POST,
    optin.toRequestBody(),
    user
  )
}

export const updateUser = (user, body, disabledErrorHandler = false, followError = false) => {
  return requestWithPromise(
    `/api/User/${body.id}`,
    PATCH,
    body,
    user,
    disabledErrorHandler,
    followError
  )
}

export const updateUserOptin = (optin, user) => {
  return requestWithPromise(
    `/api/users/${user.id}/optins/${optin.id}`,
    PATCH,
    optin.toRequestBody(),
    user
  )
}

export const getUserSectors = (user, targetUser) => {
  return requestWithPromise(
    `/api/users/${targetUser.id}/sectors`,
    GET,
    null,
    user
  )
}

export const getUserSupervisedSectors = (selectedUser, user, parameters = {}) => {
  return requestWithPromise(
    `/api/users/${selectedUser.id}/supervised-sectors${makeQueryString(parameters)}`,
    GET,
    null,
    user
  )
}

export const setUserSupervisedSectors = (sectors, supervisorUser, user) => {
  return requestWithPromise(
    `/user/set-supervisor-sectors/${supervisorUser.id}`,
    POST,
    { sectors: sectors.map(s => s.id) },
    user
  )
}

export const restoreUserByEmail = (user, currentUser) => {
  return requestWithPromise(
    '/user/restore',
    PATCH,
    { email: user.email },
    currentUser,
    true,
    true
  )
}
